import { Head, useForm } from '@inertiajs/react'
import { SubmitEvent } from 'react'
import { Flex } from '@radix-ui/themes'
import StaffForm, { StaffFormData } from './_form'
import SetupForEventCallout, { setupPath } from '@/shared/events/SetupForEventCallout'
import { StaffParticipantsNewProps } from '@/types/staff_participants_new'

export default function NewStaffParticipant({ errors, event_id, event_name }: StaffParticipantsNewProps) {
  const { data, setData, post, processing } = useForm<StaffFormData>({
    participant: {
      name: '',
      location: '',
      email: '',
      phone_number: '',
      instagram: '',
      youtube: '',
      flickr: ''
    },
    staff: {
      events_worked: '',
      cashier_experience: '',
      favored_positions: '',
      days_staffed: 0,
      staffed_before: false,
      cashiered_before: false
    }
  })

  const handleSubmit = (e: SubmitEvent) => {
    e.preventDefault()
    post(setupPath('/staff_participant', { event_id, event_name }))
  }

  return (
    <>
      <Head title="Create Staff Profile" />
      <div style={{ padding: "20px", maxWidth: "800px", margin: "0 auto" }}>
        <Flex direction="column" gap="4">
          <SetupForEventCallout event_id={event_id} event_name={event_name} />
          <StaffForm
            data={data}
            setData={setData}
            onSubmit={handleSubmit}
            processing={processing}
            errors={errors}
            title="Create Staff Profile"
            submitLabel="Create Staff Profile"
          />
        </Flex>
      </div>
    </>
  )
}
